import { apiPost } from './client';
import { PRODUCT_WIKI_SLUG } from './projects';

export interface SearchResponse {
  markdown: string;
}

export function postSearch(query: string, signal: AbortSignal): Promise<SearchResponse> {
  return apiPost<SearchResponse>(`/${PRODUCT_WIKI_SLUG}/search`, { query }, signal);
}
